<script setup>
const encouragementImage =
  "/assets/img/vocab/quiz/encouragement-" + (Math.floor(Math.random() * 4) + 1) + ".gif";
</script>

<template>
  <img :src="encouragementImage" class="encouragement-image" />
</template>

<style scoped>
.encouragement-image {
  border-radius: 50%;
}
</style>
